import * as postLiveModule from './postLiveReason'

// ACTIONS
export const INITIALISE_DASHBOARD_STATE = 'candidateExperience/INITIALISE_DASHBOARD_STATE'

export const SUBMIT_FOR_REVIEW = 'offerzen/dashboard/SUBMIT_FOR_REVIEW'
export const SUBMIT_FOR_REVIEW_SUCCESS = 'offerzen/dashboard/SUBMIT_FOR_REVIEW_SUCCESS'
export const REAPPLY = 'offerzen/dashboard/REAPPLY'

// ACTION CREATORS
export const initialiseDashboardState = initialState => ({
  type: INITIALISE_DASHBOARD_STATE,
  payload: initialState,
})

export const submitForReviewSuccess = ({ dashboard_state }) => {
  return {
    type: SUBMIT_FOR_REVIEW_SUCCESS,
    payload: {
      dashboard_state,
    },
  }
}

export const submitForReview = candidateId => ({
  type: SUBMIT_FOR_REVIEW,
  meta: { candidateId },
})

export const reapply = url => ({
  type: REAPPLY,
  payload: { url, loading: true },
})

// REDUCERS
const initialState = {}

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIALISE_DASHBOARD_STATE:
      return {
        ...state,
        ...action.payload,
      }

    case postLiveModule.SUBMIT_REASON:
    case SUBMIT_FOR_REVIEW:
      return {
        ...state,
      }

    case postLiveModule.SUBMIT_REASON_SUCCESS:
    case SUBMIT_FOR_REVIEW_SUCCESS:
      return {
        ...state,
        ...action.payload.dashboard_state,
        loading: action.payload.loading,
      }

    default:
      return state
  }
}

export default dashboardReducer
